export default {
  brand: "AllChinaBuy Spreadsheet",
  brandShort: "ACB Spreadsheet",
  tagline: "Le Centre de Ressources AllChinaBuy",
  independentNote: "Ceci est une ressource d'information indépendante et n'est pas le site officiel AllChinaBuy.",

  nav: {
    home: "Accueil",
    spreadsheet: "Spreadsheet",
    categories: "Catégories",
    guides: "Guides",
    shoppingGuide: "Guide d'achat",
    browseCategories: "Parcourir les catégories",
    faq: "FAQ",
  },

  hero: {
    eyebrow: "LE CENTRE DE RESSOURCES ALLCHINABUY",
    title: "AllChinaBuy Spreadsheet — Découvrez de Meilleures Trouvailles, Vendeurs & Guides d'Achat",
    subtitle: "Explorez les trouvailles organisées du spreadsheet AllChinaBuy, les catégories de produits, les ressources QC, les infos vendeurs, les guides d'expédition et des conseils d'achat pratiques — tout au même endroit.",
    ctaPrimary: "AllChinaBuy Spreadsheet",
    ctaSecondary: "Acheter Maintenant",
    trust: "Ressource indépendante • Guides à jour • Informations orientées acheteur",
    searchPlaceholder: "Rechercher AllChinaBuy spreadsheet, chaussures, hoodies, QC, expédition...",
  },

  cards: {
    findsTitle: "Trouvailles Organisées",
    findsDesc: "Parcourez les ressources du spreadsheet AllChinaBuy par catégorie et type de produit.",
    qcTitle: "Ressources QC",
    qcDesc: "Apprenez à comprendre les photos QC, les détails produit et les infos vendeurs.",
    shippingTitle: "Guides d'Expédition",
    shippingDesc: "Comprenez les options d'expédition internationale, les coûts et les points à vérifier.",
    buyingTitle: "Guides d'Achat",
    buyingDesc: "Suivez des guides pratiques conçus pour les débutants comme les acheteurs expérimentés.",
  },

  preview: {
    title: "Aperçu du Spreadsheet AllChinaBuy",
    subtitle: "Un aperçu rapide de la façon dont notre spreadsheet organise les trouvailles, le statut QC et les infos vendeurs.",
    colProduct: "Produit",
    colCategory: "Catégorie",
    colQc: "QC",
    colSeller: "Vendeur",
    colStatus: "Statut",
    updated: "À jour",
    fresh: "Nouveau",
    verified: "Info Vérifiée",
    sellerInfo: "Info Vendeur",
  },

  categories: {
    title: "Parcourir les Catégories de Produits",
    subtitle: "Accédez directement à chaque catégorie sur le site principal et explorez les trouvailles organisées du spreadsheet AllChinaBuy.",
    dropdownLabel: "Choisir une catégorie",
    shoes: "Chaussures",
    hoodies: "Hoodies/Sweats",
    tshirts: "T-Shirts",
    jackets: "Vestes",
    pants: "Pantalons/Shorts",
    headwear: "Couvre-chefs",
    sets: "Ensembles",
    underwear: "sous-vêtements/calçons",
    jersey: "Maillots",
    accessories: "Accessoires",
    bags: "Sacs",
    belts: "Ceintures",
    perfumes: "Parfums",
    other: "Autres Articles",
  },

  content: {
    title: "Qu'est-ce que le Spreadsheet AllChinaBuy ?",
    p1: "Le spreadsheet AllChinaBuy est une ressource structurée qui regroupe les trouvailles produit, les infos vendeurs, les notes de contrôle qualité (QC) et les détails d'expédition en un seul endroit. Au lieu de faire défiler des annonces éparpillées, les acheteurs l'utilisent pour comparer les options côte à côte et faire des choix plus éclairés avant de commander.",
    p2: "Un spreadsheet AllChinaBuy bien organisé regroupe généralement les produits par catégorie — chaussures, hoodies, t-shirts, vestes, sacs et accessoires — puis ajoute des champs pratiques comme le statut QC, la fiabilité du vendeur et la date de mise à jour. Cette structure aide les débutants comme les acheteurs expérimentés à repérer plus vite les articles de qualité.",
    p3: "Au-delà de la découverte produit, le spreadsheet sert de guide d'achat. Il peut inclure des notes sur la lecture des photos QC, l'évaluation des vendeurs et les points à surveiller lors de l'expédition internationale. Combiné à nos guides, il transforme une simple liste en véritable outil de décision.",
    linkLabel: "Lire le guide complet du spreadsheet AllChinaBuy",
  },

  articleEntry: {
    title: "Guide en Vedette",
    subtitle: "Des ressources originales et approfondies rédigées autour du thème du spreadsheet AllChinaBuy.",
    cardTitle: "AllChinaBuy Spreadsheet : Le Guide d'Achat Complet",
    cardDesc: "Apprenez à utiliser le spreadsheet AllChinaBuy, à évaluer les vendeurs, à lire les photos QC et à choisir vos produits en toute confiance.",
    readMore: "Lire le Guide",
  },

  pillars: {
    title: "Découvrez nos guides d'achat",
    subtitle: "Des ressources originales et approfondies couvrant les avis, l'expédition, le QC, les vendeurs, la sécurité et plus — toutes construites autour du spreadsheet AllChinaBuy.",
    readMore: "Lire la suite",
    minRead: "min de lecture",
  },

  faq: {
    title: "Questions Fréquentes",
    q1: "Est-ce le site officiel AllChinaBuy ?",
    a1: "Non. C'est une ressource d'information indépendante qui aide les acheteurs à comprendre et utiliser les trouvailles du spreadsheet AllChinaBuy, les conseils QC et les guides d'expédition. Elle n'est pas affiliée à la plateforme officielle AllChinaBuy.",
    q2: "Que puis-je trouver dans le spreadsheet AllChinaBuy ?",
    a2: "Des trouvailles produit organisées dans des catégories comme chaussures, hoodies, t-shirts, vestes, sacs et accessoires — chacune avec des champs utiles comme le statut QC, les infos vendeur et la date de mise à jour.",
    q3: "Comment fonctionnent les catégories ?",
    a3: "Chaque bouton de catégorie et le menu déroulant vous mènent directement à la section correspondante du site principal, où vous pouvez parcourir les produits de cette catégorie.",
    q4: "Où puis-je réellement acheter ces produits ?",
    a4: "Tous les produits sont disponibles sur le site principal. Utilisez les boutons « AllChinaBuy Spreadsheet » ou « Acheter Maintenant » pour y accéder.",
  },

  footer: {
    aboutTitle: "À Propos de Ce Site",
    aboutDesc: "Un centre de ressources indépendant dédié au spreadsheet AllChinaBuy et aux acheteurs. Nous vous aidons à trouver des produits plus vite et à acheter avec de meilleures informations.",
    exploreTitle: "Explorer",
    disclaimer: "Ceci est une ressource d'information indépendante et n'est pas le site officiel AllChinaBuy sauf indication contraire.",
    rights: "Tous droits réservés.",
  },

  languages: {
    en: "English",
    fr: "Français",
    da: "Dansk",
    de: "Deutsch",
  },
};